var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61274 0.871156C9.23619 1.41668 9.29937 2.36432 8.75384 2.98778L4.36813 8.00002L8.75384 13.0123C9.29937 13.6357 9.23619 14.5834 8.61274 15.1289C7.98928 15.6744 7.04164 15.6112 6.49611 14.9878L1.24612 8.98778C0.75127 8.42224 0.75127 7.5778 1.24612 7.01226L6.49611 1.01226C7.04164 0.388809 7.98928 0.325632 8.61274 0.871156Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.svg";
export { ForwardRef as ReactComponent };